<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="fm-title1">Dedication<span epub:type="pagebreak" id="page6"></span></p>
<p class="fm-para2">To Vivienne, as ever, for unfailing support.</p>
<p class="fm-para2">‘Necessity can turn any weapon to advantage.’<br/>Publilius Syrus (fl46–29 BC), <i>Moral Sayings</i></p>
<p class="fm-para2">‘Beware the fury of the patient man.’<br/>John Dryden, ‘Absalom and Achitophel’ (1681)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Dedication.vue?a7e25e00